import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';
import { date } from '../../../../../../utils/helpers';

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 65,
    paddingHorizontal: 20
  },
  arrow: {
    width: '6'
  },
  image: {
    width: '2%',
    marginLeft: '20px',
    alignItems: 'flex-start'
  },
  spacing: {
    width: '97',
    alignItems: 'flex-start',
    alignContent: 'space-between',
    marginTop: '5',
    marginBottom: '5',
    maxLines: 1,
    textOverflow: 'ellipsis'
  },

  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  }
});

const EmployeeRoundsPdfTableFile = ({ data }: any) => {
  return (
    <Document>
      <Page style={styles.body} orientation="landscape" wrap>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between'
          }}
          fixed
        >
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              alignItems: 'flex-start',
              borderBottomColor: 'black',
              borderBottomWidth: 1,
              marginBottom: 7,
              marginTop: 20,
              fontWeight: 'bold'
            }}
          >
            <Text style={{ fontSize: 12, marginLeft: 0 }}>Department</Text>
            <Text style={{ fontSize: 12, marginLeft: 126 }}>Employee</Text>
            <Text style={{ fontSize: 12, marginLeft: 73 }}>Status</Text>
            <Text style={{ fontSize: 12, marginLeft: 85 }}>Round Type</Text>
            <Text style={{ fontSize: 12, marginLeft: 70 }}>Rounded By</Text>
            <Text style={{ fontSize: 12, marginLeft: 52 }}>Date</Text>
          </View>
          <View
            style={{
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
          />
        </View>
        {data.map((s: any) => (
          <View
            key={s.employeeId}
            style={{
              fontSize: 8,
              borderBottomColor: 'black',
              borderBottomWidth: 1
            }}
            wrap={false}
          >
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                marginRight: '20'
              }}
              wrap={false}
            >
              <View style={{ ...styles.spacing, width: 130 }}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.department}
                </Text>
              </View>
              <View style={{ ...styles.spacing, width: 145, paddingLeft: 40 }}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.employee}
                </Text>
                <Text>{s.employeeId}</Text>
              </View>
              <View style={{ ...styles.spacing }}>
                <Text>{s.status}</Text>
              </View>
              <View style={{ ...styles.spacing, width: 115 }}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.templateName}
                </Text>
              </View>
              <View style={styles.spacing}>
                <Text style={{ fontFamily: 'Helvetica-Bold' }}>
                  {s.roundedBy}
                </Text>
                <Text>{s.createdUserId}</Text>
              </View>
              <View style={styles.spacing}>
                <Text>
                  {s?.date && s.date.length === 14 ? date.dayOfYr(s?.date) : ''}
                </Text>
              </View>
            </View>
          </View>
        ))}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default EmployeeRoundsPdfTableFile;
